import { scrambleReveal } from './textScramble.js';

/**
 * "AIRCRAFT DESTROYED" overlay + restart prompt, shown centered when the A-10 is
 * lost to a terrain crash. A static, pointer-events-free badge (the actual
 * restart is the R key, handled by App); CSS drives the fade-in via the
 * `is-visible` class toggled by {@link show} / {@link hide}. On show the title
 * runs a centered "decode" reveal (see {@link scrambleReveal}).
 */
export default class DestroyedOverlay {
  constructor({ canEndMission = false } = {}) {
    const el = document.createElement('div');
    el.id = 'destroyed-overlay';

    const title = document.createElement('div');
    title.className = 'destroyed-title';
    title.textContent = 'AIRCRAFT DESTROYED';
    this.title = title;
    this.titleText = 'AIRCRAFT DESTROYED';
    this.cancelReveal = null;

    const prompt = document.createElement('div');
    prompt.className = 'destroyed-prompt';
    // Combat missions can be ended (→ score sheet) with Esc; other scenarios
    // only offer a restart.
    prompt.textContent = canEndMission
      ? 'Press R to Restart  ·  Esc to End Mission'
      : 'Press R to Restart';

    el.append(title, prompt);
    this.el = el;
    document.getElementById('app').appendChild(el);
  }

  show() {
    this.el.classList.add('is-visible');
    this.cancelReveal?.();
    this.cancelReveal = scrambleReveal(this.title, this.titleText);
  }

  hide() {
    this.el.classList.remove('is-visible');
    this.cancelReveal?.();
    this.cancelReveal = null;
    this.title.textContent = this.titleText;
  }

  dispose() {
    this.cancelReveal?.();
    this.el.remove();
  }
}
